import {
  GridStyled,
  OuterGridStyled,
  WriteupContent,
  WriteupTitle,
} from "./styles";

export default function SpecialisationWriteup(props) {
  const { specialisationList, cmsSpecialisations, ssrFilterParams } =
    props || {};

  const { specialisation } = ssrFilterParams || {};

  const filteredSpecialisation = specialisationList?.find((spec) => {
    if (!specialisation || !specialisation.length) return false;

    const { subSpecialisations } = spec;

    const subSpecIds = subSpecialisations?.map((subSpec) => subSpec.id) || [];

    // if (specialisation.length !== subSpecIds.length) return false;

    // // Check if all subSpecs from this group are selected
    // const allSubSpecsSelected = subSpecIds.every((subSpecId) =>
    //   specialisation.includes(subSpecId)
    // );

    // // Return true only if both conditions are met
    // return allSubSpecsSelected;

    // Checks if at least one element from this group are selected
    const anySubSpecSelected = subSpecIds.some((subSpecId) =>
      specialisation.includes(subSpecId)
    );

    // Return true only if both conditions are met
    return anySubSpecSelected;
  });

  let filteredCmsSpecialisations = cmsSpecialisations?.find((cmsSpec) => {
    return cmsSpec?.attributes?.slug === filteredSpecialisation?.slug;
  });

  const { name, writeup } = filteredCmsSpecialisations?.attributes || {};

  // Replace quotation marks from writeup string
  const writeupString = writeup?.replace(/"/g, "") || "";

  return name && writeup ? (
    <OuterGridStyled
      container
      justifyContent={"center"}
      alignItems={"flex-start"}
    >
      <GridStyled width={"1440px"}>
        <WriteupTitle>{name ?? "SPECIALISATION NAME"}</WriteupTitle>
        <WriteupContent
          dangerouslySetInnerHTML={{
            __html: writeupString ?? "SPECIALISATION WRITEUP",
          }}
        />
      </GridStyled>
    </OuterGridStyled>
  ) : null;
}
